import { checkBet } from "./ai.js";

export let deck = [];

// we are creating an array ( DECK) of 32 objects with 5 properties(CARD).
function initializeDeck() {
  //console.log("initializeDeck is called ")
  const card_suits = ["hearts", "spades", "diamonds", "clubs"];
  const card_rankspoints = {
    jack: 30,
    nine: 20,
    ace: 11,
    ten: 10,
    king: 3,
    queen: 2,
    eight: 0.1,
    seven: 0,
  };
  const cardTemplate = {
    src: "",
    alt: "",
    suit: "",
    rank: "",
    points: "",
  };

  for (let suit of card_suits) {
    for (let rank in card_rankspoints) {
      const tempCARD = Object.create(cardTemplate);
      tempCARD.src = "../img/" + rank + "_of_" + suit + ".png";
      tempCARD.alt = rank + "_of_" + suit;
      tempCARD.suit = suit;
      tempCARD.rank = rank;
      tempCARD.points = card_rankspoints[rank];
      deck.push(tempCARD);
    }
  }
  return deck;
}

//we use Fisher-Yates algorithm to shuffle the deck
function shuffleDeck(_deck) {
  for (
    let initial_position = _deck.length - 1;
    initial_position > 0;
    initial_position--
  ) {
    const new_position = Math.floor(Math.random() * (initial_position + 1));
    const inital_card = _deck[initial_position];
    _deck[initial_position] = _deck[new_position];
    _deck[new_position] = inital_card;
  }
  return _deck;
}

//shifting shuffle, changes only the order of the card
function cutDeck(_deck) {
  //so that the cards are not too split we try to cut in between 4 and 28
  const maxCut = 24; //max 28 since we will be adding 4 later
  var onceOrTwice = Math.random() < 0.5 ? 1 : 2;

  //console.log(maxCut,onceOrTwice);

  for (let i = 0; i < onceOrTwice; i++) {
    let randomCut = Math.floor(Math.random() * maxCut)+4; //to make the lowest possible 4
    //console.log(randomCut);
    let tempDeck = _deck.splice(randomCut);
    _deck.unshift(...tempDeck);
  }
  return _deck;
}

//deal four cards per player
function getHands(_deck) {
  const hands = {
    south: [],
    east: [],
    north: [],
    west: [],
  };

  hands.south.push(..._deck.splice(0, 4));
  hands.east.push(..._deck.splice(0, 4));
  hands.north.push(..._deck.splice(0, 4));
  hands.west.push(..._deck.splice(0, 4));
  hands.south.push(..._deck.splice(0, 4));
  hands.east.push(..._deck.splice(0, 4));
  hands.north.push(..._deck.splice(0, 4));
  hands.west.push(..._deck.splice(0, 4));

  return hands;
}

function sortHand(theHand) {
  let hearts = [];
  let clubs = [];
  let spades = [];
  let diamonds = [];

  function comparePoints(a, b) {
    return b.points - a.points;
  }

  for (let i of theHand) {
    if (i.suit === "hearts") hearts.push(i);
    if (i.suit === "clubs") clubs.push(i);
    if (i.suit === "spades") spades.push(i);
    if (i.suit === "diamonds") diamonds.push(i);
  }

  return [
    ...hearts.sort(comparePoints),
    ...spades.sort(comparePoints),
    ...diamonds.sort(comparePoints),
    ...clubs.sort(comparePoints),
  ];
}

function sortAllHands(hands) {
  //hands.south = sortHand(hands.south);
  hands.east = sortHand(hands.east);
  hands.north = sortHand(hands.north);
  hands.west = sortHand(hands.west);

  return hands;
}

export function sortMyHand(handCards) {
  return sortHand(handCards);
}

//we provide a new deck with shuffled 32 cards or we recover the last game cards
export function dealCards() {

  //if its a ongoing game, recover the cards as they are
  let shuffleddeck = deck;
  
  /*
  shuffleddeck.forEach(function (element) {
    console.log(element.alt);
  });
*/
  //if its a new game, create the cards and shuffle it properly

  if (deck.length===0) {
    deck = initializeDeck()
    shuffleddeck = shuffleDeck(deck);
  };
  
  /*
  console.log ("at the fame start");
  shuffleddeck.forEach(function (element) {
    console.log(element.alt);
  });
  */
  //we cut the deck
  let cuttedDeck = cutDeck(shuffleddeck);
  /*
  console.log ("after cut");
  cuttedDeck.forEach(function (element) {
    console.log(element.alt);
  });
  */

  let hands = getHands(cuttedDeck);

  // each player should have a hand worth of atleast 25points
  if (!enoughPoints(hands)) {
    return dealCards();
  } else if(!noFourJacks(hands)){
    return dealCards();
  }else {
    let sortedHands = sortAllHands(hands);
    //console.log(sortedHands);
    let sortedHandsWithBet = getHighBet(sortedHands);
    //console.log(sortedHandsWithBet);
    return sortedHandsWithBet;
  }
}

// each player should have a hand worth of atleast 25points
export function enoughPoints(hands) {
  for (const key in hands) {
    let pointsPerHand = 0;
    for (let i in hands[key]) {
      pointsPerHand += hands[key][i].points;
    }
    if (pointsPerHand < 25) return false;
  }
  return true;
}

// each player should not have 4 jacks
export function noFourJacks(hands) {
  for (const key in hands) {
    let jacks = 0;

    for (let i in hands[key]) {
      if(hands[key][i].points === 30){
        jacks++;
      }
    }

    if (jacks === 4) return false;
  }
  return true;
}

function getHighBet(hands) {
  const bettedHand = hands;
  bettedHand.bet = { amount: 0 };

  for (const hand in hands) {
    //si c'est notre jouer continuer
    if (hand === "south") continue;
    //console.log(`${hand}: ${hands[hand]}`);
    let bet = checkBet(hands[hand]);

    if (bet.amount > 150) {
      bettedHand.bet = bet;
      bettedHand.bet.player = hand;
      break;
    }
  }
  return bettedHand;
}
